import { useLocation, useHistory } from "react-router-dom";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import DesktopNav from "../../components/DesktopNav";
import BottomNav from "../../components/BottomNav";
import { HomeScreenType } from "../../helpers/Enums";
import { HOMEPAGE } from "../../navigation/Constants";
import "../../css/paymentPages.css";

const PaymentFailure = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* TOP NAV */}
      <div className="top_sec wf-section">
        <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
          <img src="assets/images/shoshke_logo.svg" loading="lazy" alt="logo" />
        </NavLink>
        <div className="top_content profile w-clearfix">
          <h1 className="top_title messages">התשלום נכשל</h1>
        </div>
      </div>

      {/* MAIN CONTENT - מרוכז באמצע */}
      <div className="payment-success-container">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            maxWidth: "500px",
            width: "100%",
          }}
        >
          {/* Failure Icon - X אדום */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              backgroundColor: "#dc3545",
              color: "white",
              fontSize: "70px",
              marginBottom: "30px",
              fontWeight: "bold",
              boxShadow: "0 4px 12px rgba(220, 53, 69, 0.3)",
            }}
          >
            ✕
          </div>

          {/* Title */}
          <h2
            style={{
              fontSize: "28px",
              color: "#333",
              margin: "0 0 15px 0",
              fontWeight: "600",
            }}
          >
            התשלום נכשל!
          </h2>

          {/* Subtitle */}
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              margin: "0 0 50px 0",
              lineHeight: "1.5",
            }}
          >
            נא להזין פרטים תקינים של אמצעי התשלום
          </p>

          <a href="/premiumMassage" className="prof_mood_link">
            חזור לעמוד הרכישה
          </a>
        </div>
      </div>

      {/* NAVIGATION */}
      <DesktopNav screenType={HomeScreenType.MY_PROFILE} />
      <BottomNav screenType={HomeScreenType.MY_PROFILE} />
    </>
  );
};

export default PaymentFailure;
